import React from "react";
import Barra from "../components/Barra";
import PanelCheckin from "../components/PanelCheckin";

export default function CheckinPage() {
  return (
    <div className="app-shell">
      <Barra titulo="Check-in" />
      <PanelCheckin />
    </div>
  );
}
